<template>

  <v-container grid-list-xs>
    <v-card width="600" height="auto"  class="mx-auto pa-2  rounded-lg">
      <v-layout>
        <v-flex>
          <v-btn width="34%" href='/user/login2'>App</v-btn>
          <v-btn width="34%" href='/user/login2'>new login</v-btn>
          <v-btn width="33%" href='/compo'>compo</v-btn>
          <v-btn width="33%" href='/control/controlcompo'>컨트롤compo</v-btn>

        </v-flex>
      </v-layout>

      <v-layout class="mt-2">
        <v-flex>
          <v-btn width="25%"  href='/esg/monitorEsg2'>ESG :: 구pigro</v-btn>
          <v-btn width="25%"  href='/esg/monitorEsg'>ESG</v-btn>
          <v-btn width="25%"  href='/base/weather'>기상 모니터링</v-btn>
          <v-btn width="25%"  href='/record/marketinfo'>시장정보</v-btn>
        </v-flex>
      </v-layout>

      <v-flex>
        <v-btn width="33%"  href='/esg/energycost'>에너지 요금</v-btn>
        <v-btn width="33%"  href='/record/growdata'>사육데이터 </v-btn>
        <v-btn width="34%"  href='/record/shipdata'>출하데이터 </v-btn>
      </v-flex>

      <v-layout class="mt-2">
        <v-flex>
          <v-btn width="50%"  href='/control/controlsummary' :disabled="this.$getters.userInfo.grade > 'UT03'">제어모니터링 </v-btn>
          <v-btn width="50%"  href='/control/controlset' :disabled="this.$getters.userInfo.grade > 'UT03'">환기제어 설정 </v-btn>
        </v-flex>
      </v-layout>

      <v-layout class="mt-2">
        <v-flex>
          <v-btn block href='/comp_test' >Component Test Page</v-btn>
        </v-flex>
      </v-layout>


    </v-card>
  </v-container>



</template>

<script>
export default {
  name: 'ManMenu',

  components: {
    },
  method: {
    },
}
</script>
